module.exports = [
    { key: 0, label: 'Approved' },
    { key: 1, label: 'To Approve' },
    { key: 2, label: 'Disapproved' },
    { key: 3, label: 'Sticky' },
    // { key: 4, label: 'Sticky - Select Media' }
];
